import axios from './biAxios';
import authHeader from "./authentification-header";
import { saveAs } from 'file-saver';

const API_URL = "/api/planning/";

const getList = (date, plant, product, transportId, type) => axios
    .get(`${API_URL}list?date=${date}&plant=${plant ?? ''}&product=${product ?? ''}&transportId=${transportId ?? ''}&type=${type ?? ''}`, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const removePlans = (plans) => axios
    .post(`${API_URL}removeplan`, plans, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const removeTickets = (tickets) => axios
    .post(`${API_URL}removeticket`, tickets, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const removePlan = (planId) => axios
    .post(`${API_URL}removeplan/${planId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const removeTicket = (ticketId) => axios
    .post(`${API_URL}removeticket/${ticketId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const savePlanningList = (list) => axios
    .post(`${API_URL}savelistinline`, list, { headers: authHeader() })
    .then((response) => response.data.content ?? [])
    .catch((err) => console.log("AXIOS ERROR: ", err));
const savePlanning = (data) => axios
    .post(`${API_URL}save`, data, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getPlanDetail = (planId) => axios
    .get(`${API_URL}plandetail/${planId}`, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const getTicketDetail = (ticketId) => axios
    .get(`${API_URL}ticketdetail/${ticketId}`, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const importByText = (plant, date, mode, text) => {
    const formData = new FormData();
    formData.append('text', text);
    return axios
        .post(`${API_URL}importtext?plant=${plant ?? ''}&date=${date ?? ''}&mode=${mode ?? ''}`, formData, { headers: authHeader() })
        .then((response) => response.data.content)
        .catch((err) => console.log("AXIOS ERROR: ", err));
}
const importByFile = (plant, date, mode, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    return axios
        .post(`${API_URL}importfile?plant=${plant ?? ''}&date=${date ?? ''}&mode=${mode ?? ''}`, formData, { headers: { ...authHeader(), 'content-type': 'multipart/form-data' }})
        .then((response) => response.data.content)
        .catch((err) => console.log("AXIOS ERROR: ", err));
}
const copyPlan = (planId) => axios
    .post(`${API_URL}copyplan/${planId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const copyTicket = (ticketId) => axios
    .post(`${API_URL}copyTicket/${ticketId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const setFastTrack = (planId, fastTrack) => axios
    .post(`${API_URL}setFastTrack/${planId ?? ''}?fastTrack=${fastTrack ?? ''}`, { }, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const setFastTrackTicket = (ticketId, fastTrack) => axios
    .post(`${API_URL}setFastTrackTicket/${ticketId ?? ''}?fastTrack=${fastTrack ?? ''}`, { }, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const exportList = (date, plant, product, transportId, type) => axios
    .get(`${API_URL}exportlist?date=${date}&plant=${plant ?? ''}&product=${product ?? ''}&transportId=${transportId ?? ''}&type=${type ?? ''}`, { headers: authHeader(), responseType: "blob" })
    .then((response) => downloadFile(response, `export-${plant} (${date}).xlsx`))
    .catch((err) => console.log("AXIOS ERROR: ", err));
const downloadTemplateUpload = (type) => axios
    .get(`/template/import/${type ?? ''}.xlsx`, { headers: authHeader(), responseType: "blob", contentType: 'application/octet-stream' })
    .then((response) => downloadFile(response, `template (${type}).xlsx`))
    .catch((err) => console.log("AXIOS ERROR: ", err));

const downloadFile = (response, filename) => {
    var disposition = response.headers['content-disposition'];
    if (disposition && disposition.indexOf('attachment') !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    var blob = response.data;
    if (blob)
        saveAs(new Blob([blob]), filename);
    return blob;
}

const checkInPlan = (planId, time) => axios
    .post(`${API_URL}checkInPlan/${planId ?? ''}?time=${time ?? 0}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const checkInTicket = (ticketId, time) => axios
    .post(`${API_URL}checkInTicket/${ticketId ?? ''}?time=${time ?? 0}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const checkOutPlan = (planId) => axios
    .post(`${API_URL}checkOutPlan/${planId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));
const checkOutTicket = (ticketId) => axios
    .post(`${API_URL}checkOutTicket/${ticketId ?? ''}`, {}, { headers: authHeader() })
    .then((response) => response.data.content)
    .catch((err) => console.log("AXIOS ERROR: ", err));

const allActions = {
    getList,
    removePlans,
    removeTickets,
    removePlan,
    removeTicket,
    savePlanningList,
    savePlanning,
    getPlanDetail,
    getTicketDetail,
    importByText,
    importByFile,
    copyPlan,
    copyTicket,
    setFastTrack,
    setFastTrackTicket,
    exportList,
    downloadTemplateUpload,
    checkInPlan,
    checkInTicket,
    checkOutPlan,
    checkOutTicket
};

export default allActions;